import getOneHikIdUrl from '@pro/common/utils/getOneHikIdUrl';
import Cookie from 'js-cookie';
import Storage from '@pro/common/dao/storage';

const logoutOnehikid = (service) => {
  service = service || `${window.location.origin}/lp/index.html${window.indexHash}`;
  if (Cookie.get(`${Storage.NAME.USER}ohLogout`) === '1' || Cookie.get('upgradeOhLogout') === '1') {
    Cookie.remove(`${Storage.NAME.USER}ohLogout`);
    Cookie.remove('upgradeOhLogout');
    // 当window.location.href被设置了值后，页面并不会马上跳转，后续的一些代码仍然会执行，并且还会触发hashchange事件。
    // 这样会导致light-front触发激活子应用的函数，进而导致全局的权限鉴定的函数被触发，
    // 从而将当前所在页面的href记录到jump-after-login中，造成错误的页面恢复逻辑。
    // 所以这里设置一个全局变量，用于判断页面当前是否处于“将要跳转到登出页面，但还没有跳转”的时间段内。
    // 发现偶现登出SSO没有成功，这里加个延时，保证登出链接
    setTimeout(() => {
      window.LOGGING_OUT = true;
      const encodedService = encodeURIComponent(service);
      window.location.href = `${getOneHikIdUrl()}logout?service=${encodedService}`;
    }, 100);
    return true;
  }
  Cookie.remove(`${Storage.NAME.USER}ohLogout`);
  //   Cookie.remove('upgradeOhLogout');
  window.location.href = service;
};

export default logoutOnehikid;
